import { FETCH_INVOICES_SEARCH_RESULTS } from "../../../../../graphql/query/Invoice";
import { invoiceFilterStore } from "../../../components/useInvoiceFilters";

const SearchedInvoices = () => {
  const tableProps = {
    dataKey: "invoicesV2",
    FETCH_QUERY: FETCH_INVOICES_SEARCH_RESULTS,
    variables: {
      ...invoiceFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedInvoices;
